import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/ant-design-vue.js'
import '@babel/polyfill'
import axios from 'axios'
import crypto from './plugins/crypto'

axios.defaults.withCredentials = true

const loginExpiryKey = 'air.loginExpiresAt'
const loginDuration = 6 * 60 * 60 * 1000
const publicPaths = ['/', '/index', '/login', '/signup', '/guide', '/honor', '/rank', '/terminal', '/info', '/info/data', '/thanks', '/certificate']
let expiryTimer

function loginExpired () {
  const expiry = Number(localStorage.getItem(loginExpiryKey))
  return !Number.isFinite(expiry) || expiry <= Date.now()
}

function checkLoginExpiry () {
  clearTimeout(expiryTimer)
  if (loginExpired()) {
    localStorage.removeItem('username')
    if (!publicPaths.includes(router.currentRoute.path)) {
      router.replace({ path: '/login', query: { expired: '1' } }).catch(() => {})
    }
    return
  }
  expiryTimer = setTimeout(checkLoginExpiry, Math.min(Number(localStorage.getItem(loginExpiryKey)) - Date.now(), loginDuration))
}

Vue.prototype.$startLoginSession = () => {
  localStorage.setItem(loginExpiryKey, String(Date.now() + loginDuration))
  checkLoginExpiry()
}

router.beforeEach((to, from, next) => {
  if (!publicPaths.includes(to.path) && loginExpired()) {
    next({ path: '/login', query: { expired: '1' } })
  } else next()
})

axios.interceptors.request.use(config => {
  if (!publicPaths.includes(router.currentRoute.path) && loginExpired()) {
    checkLoginExpiry()
    throw new axios.Cancel('登录已过期，请重新登录')
  }
  return config
})

window.addEventListener('storage', event => {
  if (event.key === loginExpiryKey || event.key === null) checkLoginExpiry()
})
window.addEventListener('focus', checkLoginExpiry)
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) checkLoginExpiry()
})
checkLoginExpiry()

Vue.prototype.$crypto = crypto
Vue.prototype.$http = axios

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
